<template>
  <vx-card title="Aggregate Reporting Participation">
    <div class="pl-10">
      <h4 class="font-semibold">Participation Settings</h4>
      <p class="font-medium w-1/2 text-justify">
        By participating in aggregate reporting, you are providing us with anonymized and
        aggregated reports on system usage and trends. We use this information to
        improve the services we offer and to inform educational content we publish for the
        legal profession.
      </p>
      <p class="font-medium w-1/2 text-justify">
        Your app data remains strictly confidential and private at all times. Confidential
        client information is not disclosed and is not identifiable.
      </p>
      <p class="font-medium w-1/2 text-justify">
        If you have any questions, feel free to email legal@clio.com
      </p>
      <a-form-item>
        <a-checkbox>
          <small class="font-semibold">Participate in aggregate reporting</small>
        </a-checkbox>
      </a-form-item>
      <a-button type="primary" size="large" class="rounded-sm">
        Save Setting
      </a-button>
    </div>
  </vx-card>

</template>

<script>
    export default {
        name: "AggregateReporting"
    }
</script>

<style scoped>

</style>
